import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/Common/badge';
import { SourceModal } from './SourceModal';
import { Citation } from '@/services/rag';

interface CitationBadgesProps {
  citations: Citation[];
}

export const CitationBadges: React.FC<CitationBadgesProps> = ({ citations }) => {
  const { t } = useTranslation();
  const [selectedCitation, setSelectedCitation] = useState<Citation | null>(null);

  return (
    <>
      <div className="flex flex-col gap-1.5">
        <span className="text-xs text-muted-foreground">{t('chatPage.sourcesLabel')}</span>
        {citations.map((citation) => (
          <Badge
            key={citation.index}
            variant="outline"
            className="w-fit cursor-pointer hover:bg-accent"
            onClick={() => setSelectedCitation(citation)}
          >
            [{citation.index}] {citation.document_name}
          </Badge>
        ))}
      </div>

      <SourceModal
        citation={selectedCitation}
        isOpen={!!selectedCitation}
        onClose={() => setSelectedCitation(null)}
      />
    </>
  );
};
